import React, {useRef, useState} from 'react'
import styled from "@emotion/styled/macro"
import { theme, device } from './Theme'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
import SvgPrev from '../images/SVGs/Prev'
import SvgNext from '../images/SVGs/Next'
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Pulse from "react-reveal/Pulse"

function BackgroundImage(props) {
    const images = withArtDirection(getImage(props.mobileImage), [
      {
        media: `${device.lg}`,
        image: getImage(props.desktopImage),
      },
    ])
    return <GatsbyImage className='backgroundImage' image={images} alt={props.alt} />
  }
const CustomSlider = (props) =>{
    const slides = props.data.reasons.map(i =>({
        index: i
    }))
   
    
    const [index, setIndex] = useState(0)

    function beforeChange(prev, next){
        setIndex(next)
    }
const slider = useRef(null);
const settings = {
    arrows: false,
    slidesToShow: 3,
    swipeToSlide: true,
    infinite: false,
    beforeChange: beforeChange,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          
          
        }
      }
    ]
  
  }
    return(
<div className='sliderHolder'>
<button className='prevNextButton' disabled={index === 0} onClick={() => slider?.current?.slickPrev()}><SvgPrev /></button>
<Slider ref={slider} {...settings}>
            {props.data.reasons.map((reason, i) =>(
                <React.Fragment key={i}>
<div dangerouslySetInnerHTML={{__html: reason.icon}} />
<div className='reason' dangerouslySetInnerHTML={{__html: reason.reason}} />
</React.Fragment>
    ))}
    
            </Slider>
            <button className='prevNextButton' disabled={index === slides.length - 1} onClick={() => slider?.current?.slickNext()}><SvgNext /></button>
</div>
    )
}

const WhyChoose = (props) =>{
    const WhyChooseContainer = styled.div`
    position: relative;
    
    @media ${device.lg}{
        display: grid;
        
    }
   
    .textAndImagesContainer{
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        margin: 6.5rem auto 24.0625rem auto;
        width: 90%;
        min-height: 0px;
        min-width: 0px; 
        z-index: 1;

        @media ${device.lg}{
            position: static;
            transform: none;
            grid-area: 1/1;
            margin: 6.5rem auto;
            max-width: 64%;
        }
        @media ${device.xl}{
            max-width: 1225px;
        }
    }
    .textContainer{
        text-align: center;
    }
    .slick-track
{
    display: flex !important;
    
}
 .slick-slide{
   text-align: center;
 }
 .prevNextButton{
     appearance: none;
     border: none;
     background-color: transparent;
     & path{
         fill: ${theme.colors.dark};
     }
     & g{
         stroke: ${theme.colors.dark};
         fill: ${theme.colors.light};
         
     }
     :disabled{
         & g{
             fill: ${theme.colors.darkerGray};
         }
     }
 }
 .sliderHolder{
     display: grid;
     grid-template-columns: 25% 48% 25%;
     grid-column-gap: 1%;
     margin: 1.625rem 0 2.0625rem 0;
 }
 .slider{
    
     @media ${device.lg}{
         display: none;
     }
 }

 .reason p{
font-weight: 800;
font-size: 1.25rem;
margin-top: 0.875rem;
 }
 .backgroundImage{
    min-height: 750px;

    @media ${device.lg}{
        aspect-ratio: 64/41;
        min-height: auto;
        grid-area: 1/1;
    }
 }
 
 .circularContainer{
    display: none;

@media ${device.lg}{
    display: block;
    text-align: center;
    margin: 3rem 0;
}
 }

 
    `
 
    



    return(
        <WhyChooseContainer>
        <BackgroundImage mobileImage={props.data.backgroundImageMobile} desktopImage={props.data.backgroundImageDesktop} alt={props.data.backgroundImageAltText} />
        <div className="textAndImagesContainer">
<div className="textContainer">
<Pulse>
    <p className="heading">
        {props.data.heading}
    </p>
</Pulse>
<Pulse delay={300}>
    <p className="subheading">
        {props.data.subheading}
    </p>
</Pulse>
<h1>
    {props.data.smallText}
</h1>
</div>
<div className="slider">
<CustomSlider data={props.data} />
            <GatsbyImage image={props.data.imageMobile} alt={props.data.altText} />
</div>
<div className="circularContainer">
<GatsbyImage image={props.data.imageDesktop} alt={props.data.altText} />
</div>

        </div>
        </WhyChooseContainer>
    )
}
export {WhyChoose}